import React from 'react'
import { List, Header } from 'semantic-ui-react'
import Countdown from "react-countdown-now"



const InstallInstructions = () => (
  <List divided relaxed ordered>
    <h2>Install Instructions</h2>
    <h6><font color="red">Last Updated on 2/25/2022</font></h6>
    <br />


    {/* <Header as="h4" textAlign="center"> */}
    <List.Item>
      <h5>Prerequisites</h5>
      <List.List>
        <List.Item>Dystater set-up file e.g. Dystater version 0.0.1-beta.</List.Item>
        <List.Item>Internet connection.</List.Item>
      </List.List>

    </List.Item>

    <List.Item>
      <h5>Install Instructions</h5>
      <List.List>
        <List.Item>Download the installer</List.Item>
        <List.Item>Run installer and follow the on-screen options to complete install.</List.Item>
        <List.Item>(Recommended) After installation go to <b>C:\Program Files (x86)\Dystater</b> and read the <i>readme.txt</i> file.</List.Item>

      </List.List>

    </List.Item>

    <List.Item>
      <h5>Windows System Configuration</h5>
      <List.List>
        <List.Item>To add Dystater to path, first go to <b>Control Panel</b>.</List.Item>
        <List.Item>Click on <b>System and Security</b> then <b>System</b>.</List.Item>
        <List.Item>On the <b>System</b> window’s left side, click on <b>Advanced system</b> setting then <b></b>.</List.Item>
        <List.Item>Under <b>User variables</b> for <i>User</i> find and click on the <b>Path variable</b> the click <b>edit</b>.</List.Item>
        <List.Item>Click <b>new</b> to add to path the paste the location of <i>dystater.exe</i> e.g. <b>C:\Users\Username\AppData\Roaming\Dystater</b>.</List.Item>
        <List.Item>Repeat step 3.4 and 3.5 for <i>dystaterd.exe</i> which is in <b>C:\Program Files (x86)\Dystater\daemon</b>.</List.Item>
        <List.Item>Click <b>Ok</b> on the <b>Edit Environment Variable</b> window, <b>Ok</b> on the <b>Environment Variables</b> window, <b>Ok</b> on the <b>System Properties</b> window. Then close the <b>System</b> window.</List.Item>
        <List.Item>Now you can run <b>dystater</b> or the <b>daemon client</b> from the command-line (Restart CMD before trying).</List.Item>
      </List.List>

    </List.Item>

    <List.Item>
      <h5>Dystater Configuration</h5>
      <List.List>
        <List.Item>Click on the <b>Windows start</b> button.</List.Item>
        <List.Item>Search <b>“cmd”</b> and on the result click on <b>Command Prompt App</b> to open it.</List.Item>
        <List.Item>In CMD, type(all commands without quotes) <b>“cd C:\Users\Username\AppData\Roaming\Dystater”</b> then press <b>Enter</b>.</List.Item>
        <List.Item>Type <b>“fsutil file createnew dystater.conf 0”</b> (Link to sample <a target="_blank" href='https://rebrand.ly/sample_conf_file'>dystater.conf</a>).</List.Item>
        <List.Item>Navigate to <b>C:\Users\Username\AppData\Roaming\Dystater</b> and open the file <i>dystater.conf</i> with a <i>text editor (Notepad)</i> and add settings using the format in the sample .conf file, and <font color="red">make sure the file has owner-readable-only permissions.</font></List.Item>
        <List.Item>Add details, <b>rpcuser</b> and <b>rpcpassword</b>.</List.Item>
        <List.Item>Add our <font color="red">new</font> main server's IP address to <b>addnode</b>, <font color="red">13.244.224.198(not available, but peers are)</font> .</List.Item>
        <List.Item>Save the file.</List.Item>
        <List.Item>The other way to pass the parameters is to use the <b>CMD</b> but that's for the more advanced users.</List.Item>
      </List.List>

    </List.Item>

    <List.Item>
      <h5>Connection to a node</h5>
      <List.List>
        <List.Item>Open the <b>Dystater application</b> then wait for it to load for some seconds.</List.Item>
        <List.Item>(Recommended) Select, <b>Settings</b> then <b>Options</b>.</List.Item>
        <List.Item>In the <b>Options dialog</b> turn-off <i>Start Dystater on system startup, Minimize to the tray instead of the taskbar</i> and <i>Minimize to the tray on close, then click OK</i>.</List.Item>
        <List.Item>You can also select the amount of <b>cpu processing power</b> you will need for <i>mining</i>.</List.Item>
        <List.Item>Wait for the <i>app</i> to connect to the <i>Dystater network</i> <i>(1 Min to 3 Min)</i>.</List.Item>
        <List.Item>If it does not connect restart the app and repeat step 5.5.</List.Item>
        <List.Item>When connection is successful the connection indicator will show a <i>number great than 0</i>.</List.Item>
        <List.Item>Now the client will start <i>downloading the blockchain</i>, so wait for it to finish.</List.Item>
        <List.Item>After the <i>Initial block download</i>, you can now click on <i>Settings</i> then <i>Generate</i> to start <i>mining Dystaters</i>.</List.Item>
        <List.Item> You can keep track of your <i>hash rate on the status bar</i>, for an average PC expect around <i>1000 - 2000 k/h per sec</i>.</List.Item>
      </List.List>



    </List.Item>

    <List.Item>
      <h2>Important (Do not skip) (More on the Bitcoin wiki)</h2>

      <List.List>
        <List.Item>

          <h4>Directory Contents</h4>
          <h5>Personally identifiable data</h5>
          <p>This section may be of use to you if you wish to send a friend the blockchain, avoiding them a hefty download.</p>
          <p><h5>wallet.dat</h5>
            <i>Contains addresses and transactions linked to them. <font color="red">Please be sure to make backups of this file. It contains the keys necessary for spending your dystaters. You should not transfer this file to any third party or they may be able to access your dystaters.</font></i>
            <h5>db.log</h5>
          May contain information pertaining to your wallet. It may be safely deleted.
          <h5>debug.log</h5>
          May contain IP addresses and transaction ID's. It may be safely deleted.
          <h5>database/ folder</h5>
This should only exist when dystater is currently running. It contains information relating to your wallet.
            </p>
        </List.Item>
        <br />
        <br />
        <List.Item>
          <h4>wallet.dat</h4>
          <p>The Dystater client stores private key information in a file named wallet.dat following the so called "bitkeys" format.
            <br />
            <br />

          The wallet.dat file contains your private keys, public keys, scripts (which correspond to addresses), key metadata (e.g. labels), and the transactions related to your wallet.
            <br />
            <br />
          It contains:

              <li>
              <ul>
                keypairs for each of your addresses

              </ul>
              <ul>
                transactions done from/to your addresses

              </ul>
              <ul>
                user preferences

              </ul>
              <ul>
                default key

              </ul>
              <ul>
                reserve keys

              </ul>
              <ul>
                accounts

              </ul>
              <ul>
                a version number

              </ul>
              <ul>
                information about the current best chain, to be able to rescan automatically when restoring from a backup.
              </ul>
              <ul>
                The wallet.dat file is located in the Dystater data directory.
              </ul>
            </li>




          It is intended that a wallet file be used on only one installation of Dystater at a time. Attempting to clone a wallet file for use on multiple computers will result in "weird behavior".</p>

        </List.Item>

      </List.List>

    </List.Item>


  </List >
)

export default InstallInstructions